import { render, staticRenderFns } from "./ProductsPerSchoolLevel.vue?vue&type=template&id=6dec996c&scoped=true"
import script from "./ProductsPerSchoolLevel.vue?vue&type=script&lang=js"
export * from "./ProductsPerSchoolLevel.vue?vue&type=script&lang=js"
import style0 from "./ProductsPerSchoolLevel.vue?vue&type=style&index=0&id=6dec996c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dec996c",
  null
  
)

export default component.exports